import styled from "styled-components";
import { Field } from "design-system/form/Field/styled";

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & ~ & ${Field} {
    margin-top: 15px;
  }
`;
